import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      background: palette.background.lightblue,
      borderRadius: palette.borderRadius.default,
      boxShadow: palette.shadows.buttonShadow,
      fontFamily: 'montserrat',
      fontWeight: 600,
      color: palette.text.secondary,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      position: 'relative',
      overflow: 'hidden',
      zIndex: 0,
      gap: '10px',
      padding: '10px 20px',
      cursor: 'pointer',
      transition: '0.3s ease',
      transform: 'scale(1)',
      '&:hover': {
        transform: 'scale(1.05)'
      }
    },
    Dashboard: {
      flexGrow: 1
    },
    title: {
      fontSize: '1.5rem',
      color: palette.text.white
    },
    paragraph: {
      fontWeight: 300,
      color: palette.text.white
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
